// @flow
import React from "react"
import { render } from "react-dom"
import { Provider } from "react-redux"
import { Router, match } from "react-router"
import { AppContainer } from "react-hot-loader"
import Chat from "@kiwicom/frontend-app/scripts/components/Chat"

import session from "common/browser/session"
import NitroProvider from "common/components/NitroProvider"
import { getTranslations } from "common/services/intl"
import { getLanguageInfo } from "common/services/staticData"
import fetchAsyncLoads from "common/utils/fetchAsyncLoads"
import store from "./store"
import history from "./history"
import commonPreRender from "common/browser/commonPreRender"
import commonPostRender from "common/browser/commonPostRender"
import postRender from "./postRender"
import getRoutes from "../router/getRouter"
import Modals from "common/components/Modals/Modals"
import cuckoo from "common/services/cuckoo/cuckoo"
import { cuckooEvents } from "common/consts/enums"
// import Semaphore from "common/components/Semaphore/Semaphore"

const routes = getRoutes(window.SP_GLOBALS.SKYPICKER_LNG)

const renderIntoId = (app, elementId) => {
  const node = document.getElementById(elementId)
  if (node) render(app, node)
}

// Actual render
// ---
match({ routes, history }, async (err, _, renderProps) => {
  try {
    commonPreRender(store)

    await fetchAsyncLoads(renderProps.components)

    const state = store.getState()

    const intl = { language: getLanguageInfo(state), translations: getTranslations(state) }

    const AppRoot = () => (
      <AppContainer>
        <Provider store={store}>
          <NitroProvider
            intl={intl}
            brand={window.__BRAND__}
            fetched={window.__FETCHED__}
            session={session}
            orbit={window.__ORBIT__}
          >
            <Router {...renderProps} />
          </NitroProvider>
        </Provider>
      </AppContainer>
    )

    renderIntoId(<AppRoot />, "react-view")

    // Modals
    // ---

    const ModalsRoot = () => (
      <AppContainer>
        <Provider store={store}>
          <Modals />
        </Provider>
      </AppContainer>
    )

    renderIntoId(<ModalsRoot />, "modals")

    // Chat
    // ---

    const ChatRoot = () => (
      <AppContainer>
        <Provider store={store}>
          <Chat />
        </Provider>
      </AppContainer>
    )

    renderIntoId(<ChatRoot />, "chat")

    // Semaphore
    // ---

    // Disabled!

    // const SemaphoreRoot = () => (
    //   <AppContainer>
    //     <Provider store={store}>
    //       <Semaphore />
    //     </Provider>
    //   </AppContainer>
    // )
    //
    // renderIntoId(<SemaphoreRoot />, "semaphore")

    // =========
    // React HMR
    // =========

    if (module.hot) {
      module.hot.accept("../router/getRouter", () => {
        renderIntoId(<AppRoot />, "react-view")
      })

      module.hot.accept("common/components/Modals/Modals", () => {
        renderIntoId(<ModalsRoot />, "modals")
      })

      module.hot.accept("../../../app/scripts/components/Chat", () => {
        renderIntoId(<ChatRoot />, "chat")
      })

      // module.hot.accept("common/components/Semaphore/Semaphore", () => {
      //   renderIntoId(<SemaphoreRoot />, "semaphore")
      // })
    }

    postRender(store)
    commonPostRender(store)
  } catch (error) {
    if (process.env.NODE_ENV === "production" && typeof window.Raven !== "undefined") {
      window.Raven.captureException(error)
    }
    cuckoo.track(cuckooEvents.GENERAL_RENDER_ERROR, { error })
  }
})
